import type { ComponentProps } from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "~/utils/cn";

const labelVariants = cva(
  "gap-2 leading-none group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center select-none group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed",
  {
    variants: {
      size: {
        sm: "text-sm font-medium",
        base: "text-base/6",
      },
    },
    defaultVariants: {
      size: "sm",
    },
  },
);

function Label({
  className,
  size,
  ...props
}: ComponentProps<"label"> & VariantProps<typeof labelVariants>) {
  return (
    <label
      data-slot="label"
      className={cn(labelVariants({ size, className }))}
      {...props}
    />
  );
}

export { Label };
